import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { comprarProduto } from '../../utils/CarrinhoUtil';

const AdicionarAoCarrinho: React.FC = () => {
  const { id, quantidade } = useParams<{ id: string; quantidade: string }>();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate(); // substitui window.location.href

  useEffect(() => {
    const adicionarAoCarrinho = async () => {
      try {
        const idProd = parseInt(id ?? '0', 10);
        const qtde = parseInt(quantidade ?? '1', 10);
        const clienteId = null;

        await comprarProduto(
          idProd,
          qtde,
          clienteId,
          setLoading,
          (message) => alert(message),
          (message) => alert(message),
          {}
        );

        navigate('/loja/carrinho');
      } catch (error) {
        console.error(error);
      }
    };

    adicionarAoCarrinho();
  }, [id, quantidade, navigate]);

  return null;
};

export default AdicionarAoCarrinho;
